import userAuthState from './state'
import userAuthActions from './actions'
import userAuthMutations from './mutations'
import userAuthGetters from './getters'

export default {
  state () {
    return userAuthState
  },
  actions: userAuthActions,
  mutations: userAuthMutations,
  getters: userAuthGetters
}
